const createOrUpdateSpace = (
  { year, token, element1, element2, element3, element4, estimates },
  { observer, spacesRepo }
) => {
  spacesRepo.createOrUpdateSpace(
    { year, token, element1, element2, element3, element4, estimates },
    {
      success: (spacesResponse) => {
        if (spacesResponse.error) {
          observer.failure(spacesResponse.error)
          return
        }

        observer.success(spacesResponse.data)
      },
      failure: (error) => {
        observer.failure(error)
      }
    }
  )
}

export default createOrUpdateSpace
